import { combineReducers } from "redux";
import authentification from "./authentification";
import message from "./message";
import dropdownMenuItems from "./dropdownMenuItems";
import tankMidnight from './tankMidnight'
import theme from './theme';
import dialog from './dialog';
import saleAtExternal from './saleAtExternal';
import userManager from './userManager';
import roleMaster from './roleMaster';
import privilegeManager from './privilegeManager';
import operationTeamMaster from './operationTeamMaster';
import emailGroup from './emailGroup';
import emailAudit from './emailAudit';
import planManagement from './planManagement';

export default combineReducers({
    authentification,
    message,
    dropdownMenuItems,
    tankMidnight,
    theme,
    dialog,
    saleAtExternal,
    userManager,
    roleMaster,
    privilegeManager,
    operationTeamMaster,
    emailGroup,
    emailAudit,
    planManagement
});